import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//constantes
const dataInicial = {
    data: {},
    fc_40: {
        fechasolicitud: fechaHoy,
        numerocliente: '',
        nombrerazonSocial: '',
        telefono: '',
        correoelectronico: '',
        hologramasmezcal: false,
        cantidadmezcal: '',
        hologramasbebidasmezcal: false,
        cantidadbebidasmezcal: '',
    },
    fc_40Map: {},
    loading: false,
    paginaActiva: 1,
    modoEdicionBorrador: false,
    modoCorreccion: false,
    cliente: [],
    dataLogin: [],
    files: [],
    dataDocumentacion: {},
    filesMap: [],
}

//types
const OBTENER_FC_40_DETALLE_EXITO = 'OBTENER_FC_40_DETALLE_EXITO'
const OBTENER_FC_40_MAP_EXITO = 'OBTENER_FC_40_MAP_EXITO'
const AGREGAR_FC_40_EXITO = 'AGREGAR_FC_40_EXITO'
const AGREGAR_FC_40_BORRADOR_EXITO = 'AGREGAR_FC_40_BORRADOR_EXITO'
const ACTUALIZAR_FC_40_ESTATUS_EXITO = 'ACTUALIZAR_FC_40_ESTATUS_EXITO'
const ELIMINAR_FC_40_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_40_SOLICITUD_EXITO_BD'
const AGREGAR_ARCHIVO_FC_40_EXITO = 'AGREGAR_ARCHIVO_FC_40_EXITO'
const ACTUALIZAR_ARCHIVO_FC_40_EXITO = 'ACTUALIZAR_ARCHIVO_FC_40_EXITO'
const OBTENER_FC_40_CONTADOR_FECHA_FOLIO_EXITO = 'OBTENER_FC_40_CONTADOR_FECHA_FOLIO_EXITO'
const OBTENER_CLIENTE_POR_LOGIN_EXITO_40 = 'OBTENER_CLIENTE_POR_LOGIN_EXITO_40'
const ACTUALIZAR_FC_40_EXITO = 'ACTUALIZAR_FC_40_EXITO'

export const agregarFC_40Accion = createAsyncThunk(
    AGREGAR_FC_40_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data }

            const agregarFC_40 = host + `FC_40/agregarFormatoFC40`
            const res = await axios.post(agregarFC_40, solicitud)

            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarFileFC_40 = createAsyncThunk(
    AGREGAR_ARCHIVO_FC_40_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await agregarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const agregarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexoFK)
    const resFile = await axios.post(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const actualizarFileFC_40 = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_FC_40_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const actualizarFC_40Estatus = createAsyncThunk(
    ACTUALIZAR_FC_40_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerContadorDeFechaFolio = createAsyncThunk(
    OBTENER_FC_40_CONTADOR_FECHA_FOLIO_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Estatus/ContadorGeneralDeFechasFolio/year=${year}`
            const res = await axios.get(fullUrl)
            const contador =
                res.data.data.resultfc_01[0].count + res.data.data.resultfc_05[0].count + res.data.data.resultfc_06[0].count +
                res.data.data.resultfc_08[0].count + res.data.data.resultfc_09[0].count + res.data.data.resultfc_30[0].count +
                res.data.data.resultfc_31[0].count + res.data.data.resultfc_33[0].count + res.data.data.resultfc_34[0].count +
                res.data.data.resultfc_35[0].count + res.data.data.resultfc_36[0].count + res.data.data.resultfc_40[0].count +
                res.data.data.resultfc_41[0].count
            return contador
        } catch (error) {
            console.log(error)
        }
    }
)
export const ObtenerClientePorLogin40 = createAsyncThunk(
    OBTENER_CLIENTE_POR_LOGIN_EXITO_40,
    async (params) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorLogin/${params.idlogin}`

            const res = await axios.get(fullUrl)
            let idcliente = res.data.data.idcliente
            let idcartera = res.data.data.idcartera
            const fullUrlActividadCliente = host + `InformacionValida/obtenerActividadClientePorCliente/${idcliente}`
            const resactividad = await axios.get(fullUrlActividadCliente)


            let comercializadordemezcal = resactividad.data.data.filter(anexo=>anexo.idtipoactividad ==5)
            let comercializadordebebidasconmezcal = resactividad.data.data.filter(anexo=>anexo.idtipoactividad ==6)
            if(comercializadordemezcal.length>0)res.data.data.comercializadordemezcal =true
            else res.data.data.comercializadordemezcal = false
            if(comercializadordebebidasconmezcal.length>0)res.data.data.comercializadordebebidasconmezcal = true
            else res.data.data.comercializadordebebidasconmezcal = false



            const fullUrlDatosLogin = host + `AnexoUsuario/obtenerDatosLoginPorCartera/${idcartera}`
            let datos = []
            const resdatoslogin = await axios.get(fullUrlDatosLogin)
            let datosLogin = []
            datosLogin.push(resdatoslogin.data.data)

            datos.push(res.data.data, datosLogin)
            return datos
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_40Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_40_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data }

            const agregarFC_40 = host + `FC_40/actualizarFormatoFC40`
            const res = await axios.put(agregarFC_40, solicitud)
            
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_40SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_40_DETALLE_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_40/obtenerFormatoFC40_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            const documentosFC_40 = []
            //FILES
            for (const i in res.data.data.fc_40archivos) {
                const { ...anexo } = res.data.data.fc_40archivos[i]
                const data = {
                    id: anexo.nameid,
                    file: { name: await getNameFile(anexo.ruta) },
                    idAnexo: anexo.idfc_40archivos,
                    idAnexoFK: res.data.data.idfc40_solicitudadquisicionholo,
                    estatus: true,
                }
                documentosFC_40.push(data)
            }
            return { data: res.data.data, documentosFC_40 }
        } catch (error) {
            console.log(error);
        }
    }
)
const getNameFile = async (ruta) => {
    let nameFile = null
    const array = ruta.split("/")
    // const array = ruta.split("\\")//local
    nameFile = array[array.length - 1]
    return nameFile
}

export const eliminarFC_40SolicitudBD = createAsyncThunk(
    ELIMINAR_FC_40_SOLICITUD_EXITO_BD,
    async (id) => {
        try {
            const fullUrlSolicitud = host + `FC_40/eliminarFormatoFC40/${id}`
            const resultDelete = await axios.delete(fullUrlSolicitud)
            return { id }
        } catch (error) {
            console.log(error);
        }
    }
)














export const obtenerFC_40Map = createAsyncThunk(
    OBTENER_FC_40_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_40_Solicitud/${solicitudId}`
            const res = await axios.get(fullUrl)
            const Map = await obtenerAchivosMap(solicitudId)
            return { data: res.data.data, filesMap: Map.filesGeneralMap }
        } catch (error) {
            console.log(error)
        }
    }
)
const obtenerAchivosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_40/obtenerFormatoFC40_ConDetalle/${idSolicitud}`
        const obtenerArchivosGeneralMap = host + `MapSolicitud/obtenerMapFC_40_ArchivosGenerales/`
        const res = await axios.get(fullUrl)
        const filesGeneral = res.data.data.fc_40archivos
        const filesGeneralMap = []

        for (const i in filesGeneral) {
            const resfiles = await axios.get(obtenerArchivosGeneralMap + filesGeneral[i].idfc_40archivos)
            if (resfiles.data.data) {
                resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_40archivos
                resfiles.data.data.nameid = ""
                filesGeneralMap.push(resfiles.data.data)
            }
        }
        let Map = { filesGeneralMap: filesGeneralMap }
        return Map
    } catch (error) {
        console.log(error);
    }
}
export const fc40Slice = createSlice({
    name: 'fc40Slice',
    initialState: dataInicial,
    reducers: {
        guardarCambiosFC_40SolicitudBorrador(state, { payload }) {
            state.data = payload
        },
        guardarCambiosFC_40SolicitudNueva(state, { payload }) {
            state.fc_40 = payload
        },
        actualizarModoBorradorFC_40(state, { payload }) {
            state.modoEdicionBorrador = payload
        },
        actualizarFC_40PaginaActiva(state, { payload }) {
            state.paginaActiva = payload
        },
        actualizarModoCorrecionFC_40(state, { payload }) {
            state.modoCorreccion = payload
        },
        resetDataFC_40(state, { payload }) {
            return dataInicial
        },

    },
    extraReducers: {
        [ObtenerClientePorLogin40.fulfilled]: (state, { payload }) => {
            state.cliente = payload[0]
            state.dataLogin = payload[1][0][0]
        },
        [obtenerFC_40SolicitudDetalle.fulfilled]: (state, { payload }) => {
            state.data = payload.data
            state.fc_40 = payload.data
            state.dataDocumentacion = payload.data
            state.files = { data: payload.documentosFC_40 }
        },
        [agregarFC_40Accion.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_40Estatus.fulfilled]: (state, { payload }) => {
        },
        [eliminarFC_40SolicitudBD.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_40Map.fulfilled]: (state, { payload }) => {
            state.fc_40Map = payload.data
            state.filesMap = payload.filesMap
        }
    },
})

//actions
export const {
    actualizarModoBorradorFC_40, actualizarFC_40PaginaActiva,
    guardarCambiosFC_40SolicitudBorrador, guardarCambiosFC_40SolicitudNueva,
    resetDataFC_40, actualizarModoCorrecionFC_40
} = fc40Slice.actions

export const FC40ReducerBeneficiario = fc40Slice.reducer